import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./store";
import axios from "axios";
import * as echarts from "echarts";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import "element-plus/dist/index.css";
import "@/utils/rem";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import directive from "./directive/index";
import baseURL from "../public/static/config.json";
import JsonViewer from "vue3-json-viewer"
import "vue3-json-viewer/dist/index.css";
import dayjs from "dayjs";
import Print from 'vue3-print-nb';
import DataVVue3 from '@kjgl77/datav-vue3';
import '@/components/style/global.less';
const app = createApp(App);
app.config.globalProperties.$echarts = echarts;
app.config.globalProperties.$baseURL = baseURL;

app
  .use(directive)
  .use(JsonViewer)
  .use(store)
  .use(Print)
  .use(DataVVue3)
  .use(ElementPlus, { locale: zhCn })
  .use(router)
  .mount("#app");
app.config.globalProperties.day = dayjs;
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
